export const getCurrentPage = (query) => {
  return typeof query.page === "string" ? parseInt(query.page, 10) : void 0;
};
